import { IQuery, ICommand, IDefineCommand, IQueryMediator } from 'core-ts-types';
import { Major } from '../builders/major_builder';
import { ITransferMajorsDatasource } from '../datasources/transfer_majors_datasource';
import { TransferTransactionModel } from '../models/transfer_transaction_model';

angular.module('capability-ng-transfer').factory(
  'searchTransferMajorsCommand',
  (
    defineCommand: IDefineCommand,
    QueryMediator: IQueryMediator,
    ngTransferMajorsDatasource: ITransferMajorsDatasource,
    ngTransferMajorTransactionModel: TransferTransactionModel,
    ngMajorBuilder: typeof Major,
    $http: ng.IHttpService
  ): ICommand => {
    return defineCommand('searchTransferMajorsCommand', function queryTransferMajors(
      deferred: ng.IDeferred<IQuery[]>,
      queryText: string = ''
    ): void {
      const selectedMajorIds = _(ngTransferMajorsDatasource.read())
        .filter((major: Major) => major.isSelected)
        .map((major) => major.id)
        .value();
      const inProgressIds = Array.from(ngTransferMajorTransactionModel.ids);
      const excludedIds = _.uniq(selectedMajorIds.concat(inProgressIds)).map((id) => Number(id));
      $http({
        method: 'GET',
        url: `catalog/program/`,
        params: {
          q: queryText,
          limit: 20
        }
      })
        .catch(deferred.reject)
        .then((response: any): void => {
          const foundMajors: any[] = _.reject(response.data.results, (major) => excludedIds.includes(major.id));
          ngTransferMajorsDatasource.model.hasMore = response.data.next !== null;

          ngTransferMajorsDatasource.rewrite(
            (source: Record<string, Major>): Record<string, Major> => {
              return _.each(source, (major: Major) => {
                major.isFound = false;
                major.searchOrdering = 0;
              });
            }
          );

          _.each(ngTransferMajorsDatasource.cursor(foundMajors), (major: Major, index: number): void => {
            major.isFound = true;
            major.searchOrdering = index + 1;
          });

          deferred.resolve(QueryMediator.runQueries(ngTransferMajorsDatasource));
        });
    });
  }
);



// WEBPACK FOOTER //
// ./app/lib/transfer/commands/search_transfer_majors_command.ts